/**
 * Storage facade for Company Score weight presets.
 *
 * Thin wrapper around the axios service functions in services/api.js, mirroring
 * MacroDashboard/macroScorePresetStore.js. A company-score preset is just the
 * flat slider state: { name, weights: { signal_key: weight, ... } }.
 */

import {
  getCompanyScorePresets,
  getCompanyScorePreset,
  saveCompanyScorePreset,
  updateCompanyScorePreset,
  deleteCompanyScorePreset,
} from '../../../services/api';

const SCHEMA_VERSION = 1;

function normalizeForSave(payload) {
  return {
    name: (payload.name || '').trim(),
    weights: payload.weights || {},
    schema_version: payload.schema_version ?? SCHEMA_VERSION,
  };
}

/** List all company-score presets owned by the current user. */
export async function listPresets() {
  const { data } = await getCompanyScorePresets();
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.results)) return data.results;
  return [];
}

/** Fetch one preset by ID. */
export async function fetchPreset(id) {
  const { data } = await getCompanyScorePreset(id);
  return data;
}

/** Create a new preset. */
export async function createPreset(payload) {
  const { data } = await saveCompanyScorePreset(normalizeForSave(payload));
  return data;
}

/** Replace an existing preset (PUT). */
export async function savePreset(id, payload) {
  const { data } = await updateCompanyScorePreset(id, normalizeForSave(payload));
  return data;
}

/** Delete a preset by ID. */
export async function removePreset(id) {
  await deleteCompanyScorePreset(id);
}
